import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import AnimatedBack from "../images/AnimatedBack.gif";
import AnimatedMarketing from "../images/AnimatedMarketing.gif";
import AnimatedMarketing1 from "../images/AnimatedMarketing1.gif";
import M1 from "../images/M1.png";
import M2 from "../images/M2.png";
import M3 from "../images/M3.png";
import M4 from "../images/M4.png";
import M5 from "../images/M5.png";
import M6 from "../images/M6.png";
import Customer from "../components/Customer";

function Marketing() {
  // detect screen size
  const isDesktop = window.innerWidth > 768;

  // styles for first image
  const marketingImgStyle = isDesktop
    ? {
        marginLeft: "150px",
        marginTop: "-100px",
        marginBottom: "80px",
        padding: "20px",
        maxWidth: "70%",
        objectFit: "cover",
        borderRadius: "30px",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
      }
    : {
        margin: "20px auto",
        padding: "10px",
        maxWidth: "90%",
        display: "block",
        objectFit: "cover",
        borderRadius: "20px",
        boxShadow: "0 2px 6px rgba(0, 0, 0, 0.15)",
      };

  // styles for second image
  const marketingImg1Style = isDesktop
    ? {
        marginLeft: "180px",
        marginBottom: "100px",
        padding: "20px",
        maxWidth: "70%",
        objectFit: "cover",
        borderRadius: "40px",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
      }
    : {
        margin: "20px auto",
        padding: "10px",
        maxWidth: "90%",
        display: "block",
        objectFit: "cover",
        borderRadius: "20px",
        boxShadow: "0 2px 6px rgba(0, 0, 0, 0.15)",
      };

  return (
    <>
      <Header />
      <div className="WebD">
        <div className="Webd-above">
          <img className="Webd-img" src={AnimatedBack} alt="" />
          <div className="Webd-above-info">
            <p className="Webd-p">Digital Marketing</p>
            <p
              className="Webd-p"
              style={{ marginTop: "0px", marginBottom: "10px" }}
            >
              Services
            </p>
            <p className="Webd-p1">
              We are a leading digital marketing company dedicated to driving
              exceptional business growth for you.
            </p>
          </div>
        </div>

        <div className="Gd-main">
          <p className="Gd-main-p">
            Purohit Technosoft specializes in digital marketing services, taking
            the burden off your shoulders by managing the complex aspects of
            marketing for you. Based in Jaipur, our marketing firm delivers
            exceptional solutions designed to boost traffic to your website or
            landing page. Whether it’s social media marketing, search engine
            optimization, or a combination of strategies, Purohit Technosoft
            ensures top-quality results to help your business thrive.
          </p>
        </div>

        {/* First Image */}
        <img src={AnimatedMarketing} alt="Marketing" style={{
    ...marketingImgStyle,
    ...(window.innerWidth > 768 ? { marginTop: "10px" } : {}), // ✅ only desktop
  }}  />

        <div className="Webd-main2">
          <p className="Webd-main2-p">
  Services Provided by Our Digital Marketing Company
</p>

<p
  className="Webd-main2-p1"
  style={
    window.innerWidth > 768
      ? { marginRight: "100px", marginLeft: "100px", padding: "0" } // ✅ Desktop
      : { margin: "20px 15px", padding: "10px" } // ✅ Mobile
  }
>
  Our digital marketing company delivers an extensive range of services,
  expertly tailored to align with the unique requirements and objectives of
  your business, ensuring optimal results and growth.
</p>

          {/* Row 1 */}
          <div className="Appd-main2-boxes">
            <div className="Appd-main2-box">
              <img className="Appd-main2-img" src={M1} alt="" />
              <p style={{ color: "black", fontWeight: "bold", fontSize: "24px" }}>
                Search Engine Optimization Services
              </p>
              <p style={{ marginTop: "20px" }}>
                With tailored off-page SEO strategies designed to reach your
                target audience, we deliver the best SEO solutions for your
                business. Our team works to transform your company into a
                recognized brand while driving daily sales growth.
              </p>
            </div>
            <div className="Appd-main2-box">
              <img className="Appd-main2-img" src={M2} alt="" />
              <p style={{ color: "black", fontWeight: "bold", fontSize: "24px" }}>
                Search Engine Marketing Services
              </p>
              <p style={{ marginTop: "20px" }}>
                Search engine marketing increases product awareness and helps
                customers make informed decisions by showcasing top products
                from various brands. This creates a lucrative opportunity for
                brand owners to attract more customers and boost their
                visibility.
              </p>
            </div>
            <div className="Appd-main2-box">
              <img className="Appd-main2-img" src={M3} alt="" />
              <p style={{ color: "black", fontWeight: "bold", fontSize: "24px" }}>
                Marketing On Social Media
              </p>
              <p style={{ marginTop: "20px" }}>
                Content creation, planning, and execution for social media,
                designed to reduce cost per lead. We implement ROI-driven social
                media marketing campaigns with compelling ad copy to maximize
                engagement and conversions.
              </p>
            </div>
          </div>

          {/* Row 2 */}
          <div className="Appd-main2-boxes">
            <div className="Appd-main2-box">
              <img className="Appd-main2-img" src={M4} alt="" />
              <p style={{ color: "black", fontWeight: "bold", fontSize: "24px" }}>
                Reputation Management Services
              </p>
              <p style={{ marginTop: "20px" }}>
                Effective reputation management services create content that
                shapes search engine results, helping to ensure your brand is
                positively represented. This can influence potential customers'
                decisions, preventing them from choosing competitors over your
                business.
              </p>
            </div>
            <div className="Appd-main2-box">
              <img className="Appd-main2-img" src={M5} alt="" />
              <p style={{ color: "black", fontWeight: "bold", fontSize: "24px" }}>
                Conversion Optimization Services
              </p>
              <p style={{ marginTop: "20px" }}>
                Our experienced team will help enhance your online performance
                by designing a customized conversion optimization strategy. We
                then implement thorough A/B/N and multivariate testing to refine
                your approach and ensure maximum conversion rates.
              </p>
            </div>
            <div className="Appd-main2-box">
              <img className="Appd-main2-img" src={M6} alt="" />
              <p style={{ color: "black", fontWeight: "bold", fontSize: "24px" }}>
                Online Publicity Services
              </p>
              <p style={{ marginTop: "20px" }}>
                Online public relations can effectively market your products and
                services while boosting brand and company awareness. PR content
                shared across your social media platforms not only engages your
                audience but also contributes to enhancing your website's SEO.
              </p>
            </div>
          </div>
        </div> jkkjb

        {/* Second Image */}
        <img src={AnimatedMarketing1} alt="Marketing 2" style={marketingImg1Style} />
      </div>

      <Customer />
      <Footer />
    </>
  );
}

export default Marketing;
